// DS: CR28
import React, { useCallback, useRef, useMemo, useContext } from 'react';
import classnames from 'classnames';
import throttle from 'lodash/throttle';
import { useTranslation } from 'react-i18next';
import { Url } from '@wix/da-url';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NotificationIcon from '@wix/da-ds/pkg/Icons/24x24/Notification';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { useBiLogger } from '@wix/da-bi/pkg/hooks/useBiLogger';
import { NCContext } from '@wix/da-react-context/pkg/NCContext';
import { FirstTimeFlag } from '../../../redux/firstTimeFlags';
import { useOnOutsideClick } from '../../../utils/hooks/useOnOutsideClick';
import SophisticatedFtueTooltip from '../../../Popover/Preset/SophisticatedFtueTooltip';
import noop from '../../../utils/noop';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import SiteHeaderStyles from '../SiteHeaderDesktop.scss';
import s from './NotificationsDropdownWrapper.scss';
var NotificationsDropdownWrapper = function (_a) {
    var feedbackCount = _a.feedbackCount, isOpen = _a.isOpen, onMouseEnter = _a.onMouseEnter, onTouchEnd = _a.onTouchEnd, biData = _a.biData, isLegacyHeader = _a.isLegacyHeader, isFeedbackPageOpen = _a.isFeedbackPageOpen, _b = _a.onMouseLeave, onMouseLeave = _b === void 0 ? noop : _b, toggleFeedbackPage = _a.toggleFeedbackPage, ariaLabel = _a["aria-label"];
    var t = useTranslation().t;
    var _c = useContext(NCContext), DrawerComponent = _c.DrawerComponent, isStandalonePage = _c.isStandalonePage;
    var logBiEvent = useBiLogger();
    var ncNew = useFlag('nc_new');
    // TODO no idea why we use setTimeout for mouseenter/leave in this component,
    // useNotificationDropdownHover already deals with timeouts.
    // no point to spamming this if our guest has twitchy hands
    var throttledMouseLeave = useMemo(function () { return throttle(onMouseLeave, 300); }, [onMouseLeave]);
    var rootRef = useRef(null);
    var onClose = useCallback(function (event) {
        if (event === void 0) { event = {}; }
        throttledMouseLeave(event);
    }, [throttledMouseLeave]);
    var handleClickOutside = useCallback(function () {
        if (!isOpen) {
            return;
        }
        onClose();
    }, [isOpen, onClose]);
    useOnOutsideClick(rootRef, handleClickOutside);
    var handleIconClick = useCallback(function () {
        if (isLegacyHeader) {
            // eslint-disable-next-line @wix/da/window-object-typeof-check
            window.location.assign(Url.feedbackLink(ncNew));
            return;
        }
        if (!isStandalonePage) {
            toggleFeedbackPage();
        }
    }, [isStandalonePage, isLegacyHeader, toggleFeedbackPage, ncNew]);
    var timerRef = useRef(null);
    return (React.createElement("div", { className: classnames(SiteHeaderStyles['icon-button-has-submenu'], SiteHeaderStyles['icon-button-has-notifications-submenu']), onMouseEnter: function (e) {
            if (!isFeedbackPageOpen && !isStandalonePage) {
                if (!ncNew) {
                    timerRef.current = setTimeout(function () {
                        return logBiEvent({
                            evid: BiEventType.PAGEVIEW,
                            view: 'notifications',
                            component: 'header',
                        });
                    }, 100);
                }
                onMouseEnter(e);
            }
        }, onMouseLeave: function (e) {
            if (!ncNew) {
                clearTimeout(timerRef.current);
            }
            onClose(e);
        }, onTouchEnd: onTouchEnd, ref: rootRef },
        React.createElement(SophisticatedFtueTooltip, { heading: t('siteHeader.notificationsMenu.ftue.heading'), description: t('siteHeader.notificationsMenu.ftue.description'), size: "medium", placement: "bottom", width: 286, flag: FirstTimeFlag.IsNewNCHeaderNotAcknowledged },
            React.createElement(BiButton, { biData: biData, className: classnames(SiteHeaderStyles['icon-button'], isOpen && SiteHeaderStyles['toggled'], feedbackCount !== '0' && s['extra-margin-for-indicator']), "aria-label": ariaLabel, onClick: handleIconClick },
                React.createElement("span", null,
                    React.createElement(NotificationIcon, { className: SiteHeaderStyles['notifications-icon'], size: IconSize.MEDIUM }),
                    feedbackCount !== '0' && (React.createElement("span", { className: SiteHeaderStyles['number'] }, feedbackCount))))),
        DrawerComponent && !isStandalonePage && (React.createElement("div", { role: "dialog", id: "site-header-notifications", className: s['notifications-dropdown-wrapper'] },
            React.createElement("div", { className: classnames(s['container'], isOpen && s['active']) }, isOpen && (React.createElement(DrawerComponent, { isDropdown: true, openFeedbackPage: function () {
                    return toggleFeedbackPage && toggleFeedbackPage();
                } })))))));
};
NotificationsDropdownWrapper.displayName = 'NotificationsDropdownWrapper';
export default NotificationsDropdownWrapper;
//# sourceMappingURL=NotificationsDropdownWrapper.js.map